<mat-card-title>{{'LOGOUT_SUCCESS.SUCCESS' | translate}}</mat-card-title>

<div class="container" fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="0.5%" fxLayoutAlign="center">
    <div fxFlex="20%">
        <img mat-card-image src="assets/img/hand-wave.svg" alt="Image of hand waving goodbye">
    </div>
</div>

<mat-card-content>
    <p>
        {{'LOGOUT_SUCCESS.GOODBYE' | translate}}
    </p>
</mat-card-content>
<mat-card-actions>
    <app-button (clickEvent)="commonFunc.getRedirectedByRequestId()" [btnOption]="buttonOptions.backToLogin">
    </app-button>
</mat-card-actions>